import angular from 'angular';
import { postPinIntelComponent } from './postPinIntelComponent';
import 'components/sharpr/post/pin/footer/postPinFooterModule';

angular
	.module('sh.postPinIntel', [
		'sh.postPinUnapproved',
		'sh.image',
		'sh.cfg',
		'sh.postPinBody',
		'sh.postReadMore',
		'sh.avatar',
		'sh.postIndicators',
		'sh.postPinFooter',
		'sh.dateFormat',
	])
	.component('shPostPinIntel', postPinIntelComponent());
